module.exports = __webpack_public_path__ + "img/goods13_1.116ba611.jpg";